// extracted by mini-css-extract-plugin
export default {"socialShareWrapper":"lz7dG","icon":"vjoku"};